import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import {
  IncidentBannerService,
  IncidentBannerState,
} from 'src/app/services/incident-banner.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { SuperAdminContextService } from 'src/app/services/super-admin-context.service';
import {
  IncidentEditDialogComponent,
  IncidentEditDialogResult,
} from './incident-edit-dialog/incident-edit-dialog.component';

@Component({
  selector: 'app-super-admin-menu',
  templateUrl: './super-admin-menu.component.html',
  styleUrls: ['./super-admin-menu.component.css'],
})
export class SuperAdminMenuComponent implements OnInit, OnDestroy {
  state: IncidentBannerState = { enabled: false, message: '', updated_at: null, updated_by_uid: null };

  saving = false;

  private sub?: Subscription;

  constructor(
    public permissions: PermissionsService,
    private bannerService: IncidentBannerService,
    private superAdminContext: SuperAdminContextService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.superAdminContext.present = true;
    // Ensure the CSS var is set immediately, so don't wait for IncidentBanner
    // to react, since it may not be mounted yet at login time.
    document.documentElement.style.setProperty('--super-admin-menu-height', '36px');
    // Body class lets global CSS push CDK overlays (dialogs) below the bar
    // without relying on CSS :has() (Safari < 15.4 doesn't support it).
    document.body.classList.add('has-super-admin-bar');
    this.sub = this.bannerService.banner$.subscribe((s) => (this.state = s));
    // Fetch fresh banner state on login (service may have stale data from
    // before the auth event).
    this.bannerService.refresh();
  }

  ngOnDestroy(): void {
    this.superAdminContext.present = false;
    document.body.classList.remove('has-super-admin-bar');
    this.sub?.unsubscribe();
  }

  toggleIncidentBanner(): void {
    this.saving = true;
    this.bannerService.update(!this.state.enabled, this.state.message).subscribe({
      next: () => (this.saving = false),
      error: () => (this.saving = false),
    });
  }

  openEditDialog(): void {
    const ref = this.dialog.open<
      IncidentEditDialogComponent,
      { message: string },
      IncidentEditDialogResult
    >(IncidentEditDialogComponent, {
      width: '640px',
      height: 'auto',
      maxWidth: '95vw',
      panelClass: 'incident-dialog-panel',
      data: { message: this.state.message },
      autoFocus: true,
      restoreFocus: true,
    });

    ref.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }
      this.saving = true;
      this.bannerService.update(this.state.enabled, result.message).subscribe({
        next: () => (this.saving = false),
        error: () => (this.saving = false),
      });
    });
  }
}
